<section class="w3l-form-25">
  <div class="w3l-form-25">
    <BR>
   <label style="width: 250px;">   </label>
   <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
   <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
 </div>
 <div class="form-inner-cont">
  <div class="w3l-form-25">
      <h1>{{'Accounting Reports Data' | translate }}</h1>
      <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{ 'Patient Invoices' | translate }}</h1>
  </div>
</div>

<div id="w3l-appointment">
  <div class="wrapper">
  <div class="d-grid doctor-appointment">
    <form action="#" method="post" >

        <form >
          <div class="appointment-form-field">
            <label style="width: 150px;">{{ 'Patient' | translate }}</label>
            <input type="text" name="pacode"  required="" style="width: 100px;" [(ngModel)]="w_patient" (change)="RetrivePatient()" >
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogPatient()"></span>
            <label id="w3l-appointment" class="appointment-form-field" style="width: 400px;background-color:  rgb(187, 203, 238);border-style: solid;border-width: .5px;border-color: slategray;">{{trcln_supp_Namme}}</label>
          </div>
        </form>


        <BR>
          <form >
            <div class="appointment-form-field">
              <label style="width: 150px;">{{ 'From Date' | translate }}</label>
              <input type="date" name="revname" style="width: 200px;" [(ngModel)]="FromDate" >
              <label style="width: 50px;"></label>
              <label style="width: 100px;">{{ 'To Date' | translate }}</label>
              <input type="date" name="revname" style="width: 200px;" [(ngModel)]="ToDate" >
              <label style="width: 10px;"></label>
              <button name="BDrug" class="theme-button btn fa fa-refresh" style="width: 100px;height: 50px;" required (click)="RetrivePatient()">  Refresh</button>
              <label style="width: 10px;"></label>
              <button name="print" class="theme-button btn fa fa-print" style="width: 100px;height: 50px;" required (click)="PrintInvoices()">  Print</button>

            </div>
          </form>


    </form>
  </div>
  </div>
</div>
<BR>
  <div id="w3l-appointment">
    <div class="wrapper">
    <div class="d-grid doctor-appointment">
      <form action="#" method="post" >

          <table style="width: 850px;">
            <thead >
                <tr >
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 20%;height: 20%;text-align: center;">{{ 'Invoice No' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white;width: 20%;height: 20%;text-align: center;">{{ 'Invoice Date' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:20%;height: 20%;text-align: center;">{{ 'Total' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;text-align: center;">{{ 'Discount' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:20%;height: 10%;text-align: center;">{{ 'Net Value' | translate }}</th>
                    <th style="background-color:  rgb(70, 70, 247);color: white; width:10%;height: 10%;text-align: center;">{{ 'Print' | translate }}</th>

                </tr>
            </thead>
            <tbody>

              <tr *ngFor="let pro of InvoiceListList; let i = index" style="height: 50%;font-weight: bold;">
                <td data-column="Patient ID" style="height: 10%;text-align: center;">{{pro.w_serial}}</td>
                <td data-column="Patient Name"style="height: 100%;a">{{pro.w_date}}</td>
                <td data-column="Patient Name"style="height: 10%;">{{pro.w_amount | number:'1.2-2'}}</td>
                <td data-column="Patient Name"style="height: 10%;">{{pro.w_desc | number:'1.2-2'}}</td>
                <td data-column="Patient Name"style="height: 10%;">{{pro.w_net | number:'1.2-2'}}</td>
                <a href="AccInvoice" class="drop-text" target="_blank">
                  <button type="button"  name="stores" style="width: 100%;height: 35px;"  (click)="SelectLine(pro)">{{'Invoice' | translate }}</button>
                   </a>
                <!-- <a href="AccInvoice" class="drop-text">
                 <button name="BDrug" style="width: 100%;height: 35px;" required (click)="SelectLine(pro)">Print</button>
                </a> -->
              </tr>
            </tbody>
          </table>
      </form>
    </div>
    </div>
  </div>
<BR>

  <BR>
  <!-- <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px; font-weight: bold;" name="print" (click)="Print()">{{ 'Print' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Delete" (click)="Exit()">{{ 'Home' | translate }}</button>

  </form> -->
  <BR>
    <BR>

</section>



